export const LIGHT_PURPLE = '#B975FF';
export const LIGHT_PURPLE_HOVER = 'rgba(185, 117, 255, 0.2)'; 